import { LOAD_ALL_DIETARY_INFO_SUCCESS } from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_ALL_DIETARY_INFO_SUCCESS:
            return action.payload
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/DietaryInfoReducer.js